export default __webpack_public_path__ + "static/media/photo--lg--kara2.58040cae.jpg";